module.exports = [
  {
    "geoid": "22051020101",
    "pctBlack": 3.3,
    "LE": 76.3,
    "pctBachPlus": 28.7
  },
  {
    "geoid": "22051020102",
    "pctBlack": 1,
    "LE": 81.3,
    "pctBachPlus": 31.5
  },
  {
    "geoid": "22051020201",
    "pctBlack": 10.4,
    "LE": 80.2,
    "pctBachPlus": 40.9
  },
  {
    "geoid": "22051020203",
    "pctBlack": 2.2,
    "LE": 82.1,
    "pctBachPlus": 45.8
  },
  {
    "geoid": "22051020301",
    "pctBlack": 3.5,
    "LE": 81.4,
    "pctBachPlus": 49.3
  },
  {
    "geoid": "22051020302",
    "pctBlack": 2.3,
    "LE": 80.7,
    "pctBachPlus": 43.9
  },
  {
    "geoid": "22051020303",
    "pctBlack": 0.1,
    "LE": 80.3,
    "pctBachPlus": 32.7
  },
  {
    "geoid": "22051020400",
    "pctBlack": 0.2,
    "LE": 80.6,
    "pctBachPlus": 58
  },
  {
    "geoid": "22051020502",
    "pctBlack": 12.8,
    "LE": 79.2,
    "pctBachPlus": 14.2
  },
  {
    "geoid": "22051020507",
    "pctBlack": 5.3,
    "LE": 79.5,
    "pctBachPlus": 23.9
  },
  {
    "geoid": "22051020508",
    "pctBlack": 17,
    "LE": 80.5,
    "pctBachPlus": 26.4
  },
  {
    "geoid": "22051020511",
    "pctBlack": 14.7,
    "LE": 80.7,
    "pctBachPlus": 32
  },
  {
    "geoid": "22051020512",
    "pctBlack": 4.3,
    "LE": 78.6,
    "pctBachPlus": 36.7
  },
  {
    "geoid": "22051020513",
    "pctBlack": 23.1,
    "LE": 79.3,
    "pctBachPlus": 30
  },
  {
    "geoid": "22051020514",
    "pctBlack": 0,
    "LE": 82.7,
    "pctBachPlus": 48.5
  },
  {
    "geoid": "22051020515",
    "pctBlack": 13.3,
    "LE": 78.2,
    "pctBachPlus": 23
  },
  {
    "geoid": "22051020516",
    "pctBlack": 31.6,
    "LE": 74.9,
    "pctBachPlus": 10.1
  },
  {
    "geoid": "22051020517",
    "pctBlack": 5.1,
    "LE": 79.8,
    "pctBachPlus": 43.2
  },
  {
    "geoid": "22051020600",
    "pctBlack": 83.2,
    "LE": 74.4,
    "pctBachPlus": 5.3
  },
  {
    "geoid": "22051020700",
    "pctBlack": 46.1,
    "LE": 68.8,
    "pctBachPlus": 4.9
  },
  {
    "geoid": "22051021000",
    "pctBlack": 31.6,
    "LE": 75.4,
    "pctBachPlus": 11.7
  },
  {
    "geoid": "22051021100",
    "pctBlack": 8.5,
    "LE": 74.6,
    "pctBachPlus": 13.2
  },
  {
    "geoid": "22051021200",
    "pctBlack": 16.1,
    "LE": 75.5,
    "pctBachPlus": 11.8
  },
  {
    "geoid": "22051021300",
    "pctBlack": 10.2,
    "LE": 77.7,
    "pctBachPlus": 23.9
  },
  {
    "geoid": "22051021400",
    "pctBlack": 4.7,
    "LE": 80.9,
    "pctBachPlus": 32.9
  },
  {
    "geoid": "22051021500",
    "pctBlack": 32.5,
    "LE": 72.6,
    "pctBachPlus": 18.2
  },
  {
    "geoid": "22051021600",
    "pctBlack": 7.5,
    "LE": 78.9,
    "pctBachPlus": 23.7
  },
  {
    "geoid": "22051021700",
    "pctBlack": 8.9,
    "LE": 77,
    "pctBachPlus": 36.5
  },
  {
    "geoid": "22051021801",
    "pctBlack": 7.5,
    "LE": 78.2,
    "pctBachPlus": 32.9
  },
  {
    "geoid": "22051021803",
    "pctBlack": 37.5,
    "LE": 75.9,
    "pctBachPlus": 22.6
  },
  {
    "geoid": "22051021804",
    "pctBlack": 19.9,
    "LE": 74.4,
    "pctBachPlus": 7.9
  },
  {
    "geoid": "22051021900",
    "pctBlack": 16.5,
    "LE": 77.6,
    "pctBachPlus": 23.5
  },
  {
    "geoid": "22051022001",
    "pctBlack": 37.5,
    "LE": 75.8,
    "pctBachPlus": 24.5
  },
  {
    "geoid": "22051022002",
    "pctBlack": 2.9,
    "LE": 80.1,
    "pctBachPlus": 40.1
  },
  {
    "geoid": "22051022101",
    "pctBlack": 0.1,
    "LE": 81.3,
    "pctBachPlus": 58.4
  },
  {
    "geoid": "22051022102",
    "pctBlack": 13.9,
    "LE": 80.9,
    "pctBachPlus": 35.7
  },
  {
    "geoid": "22051022200",
    "pctBlack": 1.4,
    "LE": 74.1,
    "pctBachPlus": 36.5
  },
  {
    "geoid": "22051022301",
    "pctBlack": 0.6,
    "LE": 80.8,
    "pctBachPlus": 33
  },
  {
    "geoid": "22051022302",
    "pctBlack": 6.6,
    "LE": 75.7,
    "pctBachPlus": 22.5
  },
  {
    "geoid": "22051022303",
    "pctBlack": 9.4,
    "LE": 78.4,
    "pctBachPlus": 25.1
  },
  {
    "geoid": "22051022400",
    "pctBlack": 1.6,
    "LE": 81.5,
    "pctBachPlus": 53.5
  },
  {
    "geoid": "22051022500",
    "pctBlack": 2.9,
    "LE": 81.5,
    "pctBachPlus": 49.4
  },
  {
    "geoid": "22051022600",
    "pctBlack": 2.2,
    "LE": 82.8,
    "pctBachPlus": 75.8
  },
  {
    "geoid": "22051022700",
    "pctBlack": 0,
    "LE": 81.8,
    "pctBachPlus": 46.7
  },
  {
    "geoid": "22051022800",
    "pctBlack": 0,
    "LE": 78.1,
    "pctBachPlus": 25.9
  },
  {
    "geoid": "22051022900",
    "pctBlack": 6,
    "LE": 75.2,
    "pctBachPlus": 19.6
  },
  {
    "geoid": "22051023001",
    "pctBlack": 2.5,
    "LE": 80.5,
    "pctBachPlus": 31.5
  },
  {
    "geoid": "22051023002",
    "pctBlack": 2.4,
    "LE": 82,
    "pctBachPlus": 35
  },
  {
    "geoid": "22051023003",
    "pctBlack": 2.4,
    "LE": 80.8,
    "pctBachPlus": 30.7
  },
  {
    "geoid": "22051023100",
    "pctBlack": 1.1,
    "LE": 79.4,
    "pctBachPlus": 20
  },
  {
    "geoid": "22051023200",
    "pctBlack": 3.6,
    "LE": 73.2,
    "pctBachPlus": 26
  },
  {
    "geoid": "22051023300",
    "pctBlack": 2.8,
    "LE": 76.5,
    "pctBachPlus": 26.5
  },
  {
    "geoid": "22051023400",
    "pctBlack": 2,
    "LE": 77.8,
    "pctBachPlus": 30.9
  },
  {
    "geoid": "22051023500",
    "pctBlack": 3.3,
    "LE": 76.8,
    "pctBachPlus": 15.6
  },
  {
    "geoid": "22051023600",
    "pctBlack": 15.1,
    "LE": 73.9,
    "pctBachPlus": 15.5
  },
  {
    "geoid": "22051023700",
    "pctBlack": 96.4,
    "LE": 72.4,
    "pctBachPlus": 6.2
  },
  {
    "geoid": "22051023800",
    "pctBlack": 35,
    "LE": 74.4,
    "pctBachPlus": 22.8
  },
  {
    "geoid": "22051023901",
    "pctBlack": 0.4,
    "LE": 77.7,
    "pctBachPlus": 28.7
  },
  {
    "geoid": "22051023902",
    "pctBlack": 2.6,
    "LE": 80.9,
    "pctBachPlus": 55.9
  },
  {
    "geoid": "22051023903",
    "pctBlack": 0.2,
    "LE": 80.4,
    "pctBachPlus": 40.7
  },
  {
    "geoid": "22051023904",
    "pctBlack": 3.9,
    "LE": 80,
    "pctBachPlus": 42.5
  },
  {
    "geoid": "22051024001",
    "pctBlack": 1.2,
    "LE": 77,
    "pctBachPlus": 27.7
  },
  {
    "geoid": "22051024100",
    "pctBlack": 6.9,
    "LE": 76.4,
    "pctBachPlus": 17.5
  },
  {
    "geoid": "22051024201",
    "pctBlack": 9.3,
    "LE": 74.6,
    "pctBachPlus": 29.5
  },
  {
    "geoid": "22051024202",
    "pctBlack": 22.2,
    "LE": 79.2,
    "pctBachPlus": 46.7
  },
  {
    "geoid": "22051024300",
    "pctBlack": 6.7,
    "LE": 78,
    "pctBachPlus": 30.9
  },
  {
    "geoid": "22051024400",
    "pctBlack": 21.5,
    "LE": 75.4,
    "pctBachPlus": 23.8
  },
  {
    "geoid": "22051024500",
    "pctBlack": 1.6,
    "LE": 77.3,
    "pctBachPlus": 28.2
  },
  {
    "geoid": "22051024600",
    "pctBlack": 65.6,
    "LE": 74.1,
    "pctBachPlus": 9.2
  },
  {
    "geoid": "22051024700",
    "pctBlack": 25.6,
    "LE": 70.2,
    "pctBachPlus": 23
  },
  {
    "geoid": "22051024800",
    "pctBlack": 0.4,
    "LE": 82.5,
    "pctBachPlus": 67.3
  },
  {
    "geoid": "22051024900",
    "pctBlack": 21.7,
    "LE": 68.8,
    "pctBachPlus": 17.3
  },
  {
    "geoid": "22051025001",
    "pctBlack": 50.6,
    "LE": 74.7,
    "pctBachPlus": 23.6
  },
  {
    "geoid": "22051025002",
    "pctBlack": 26,
    "LE": 73,
    "pctBachPlus": 12.2
  },
  {
    "geoid": "22051025003",
    "pctBlack": 18.8,
    "LE": 75.8,
    "pctBachPlus": 18.8
  },
  {
    "geoid": "22051025102",
    "pctBlack": 22.4,
    "LE": 77.8,
    "pctBachPlus": 37.6
  },
  {
    "geoid": "22051025103",
    "pctBlack": 40.1,
    "LE": 78.1,
    "pctBachPlus": 17.5
  },
  {
    "geoid": "22051025104",
    "pctBlack": 38.8,
    "LE": 77,
    "pctBachPlus": 17.3
  },
  {
    "geoid": "22051025201",
    "pctBlack": 41.3,
    "LE": 73.6,
    "pctBachPlus": 11.8
  },
  {
    "geoid": "22051025202",
    "pctBlack": 33.4,
    "LE": 74.5,
    "pctBachPlus": 16.1
  },
  {
    "geoid": "22051025300",
    "pctBlack": 6.4,
    "LE": 76.8,
    "pctBachPlus": 27.3
  },
  {
    "geoid": "22051025400",
    "pctBlack": 36.3,
    "LE": 74.9,
    "pctBachPlus": 10.2
  },
  {
    "geoid": "22051025500",
    "pctBlack": 53.2,
    "LE": 75.5,
    "pctBachPlus": 3.7
  },
  {
    "geoid": "22051025600",
    "pctBlack": 20.6,
    "LE": 74.3,
    "pctBachPlus": 25.4
  },
  {
    "geoid": "22051025700",
    "pctBlack": 71.1,
    "LE": 69,
    "pctBachPlus": 12.4
  },
  {
    "geoid": "22051025800",
    "pctBlack": 47.9,
    "LE": 70.9,
    "pctBachPlus": 12.1
  },
  {
    "geoid": "22051025900",
    "pctBlack": 39.2,
    "LE": 75.1,
    "pctBachPlus": 19.5
  },
  {
    "geoid": "22051026000",
    "pctBlack": 15.1,
    "LE": 69.3,
    "pctBachPlus": 9.6
  },
  {
    "geoid": "22051026100",
    "pctBlack": 47.6,
    "LE": 71.1,
    "pctBachPlus": 6
  },
  {
    "geoid": "22051026300",
    "pctBlack": 10.3,
    "LE": 75.6,
    "pctBachPlus": 18
  },
  {
    "geoid": "22051026400",
    "pctBlack": 7,
    "LE": 73.9,
    "pctBachPlus": 11
  },
  {
    "geoid": "22051026500",
    "pctBlack": 13.7,
    "LE": 72.3,
    "pctBachPlus": 14.4
  },
  {
    "geoid": "22051026600",
    "pctBlack": 4.5,
    "LE": 71.5,
    "pctBachPlus": 10.9
  },
  {
    "geoid": "22051026700",
    "pctBlack": 30.2,
    "LE": 71.2,
    "pctBachPlus": 11.2
  },
  {
    "geoid": "22051026800",
    "pctBlack": 77.4,
    "LE": 68,
    "pctBachPlus": 11.1
  },
  {
    "geoid": "22051026900",
    "pctBlack": 93.2,
    "LE": 72.2,
    "pctBachPlus": 11.1
  },
  {
    "geoid": "22051027000",
    "pctBlack": 36.2,
    "LE": 71.9,
    "pctBachPlus": 8.7
  },
  {
    "geoid": "22051027100",
    "pctBlack": 16.2,
    "LE": 72.7,
    "pctBachPlus": 11.6
  },
  {
    "geoid": "22051027200",
    "pctBlack": 27.1,
    "LE": 72.1,
    "pctBachPlus": 5.7
  },
  {
    "geoid": "22051027501",
    "pctBlack": 58.3,
    "LE": 73.8,
    "pctBachPlus": 18.6
  },
  {
    "geoid": "22051027502",
    "pctBlack": 99.7,
    "LE": 73.1,
    "pctBachPlus": 13.8
  },
  {
    "geoid": "22051027601",
    "pctBlack": 34.1,
    "LE": 73,
    "pctBachPlus": 4.3
  },
  {
    "geoid": "22051027602",
    "pctBlack": 63.3,
    "LE": 72.6,
    "pctBachPlus": 7.1
  },
  {
    "geoid": "22051027701",
    "pctBlack": 95.4,
    "LE": 73.1,
    "pctBachPlus": 7.2
  },
  {
    "geoid": "22051027703",
    "pctBlack": 55,
    "LE": 71.9,
    "pctBachPlus": 12.5
  },
  {
    "geoid": "22051027803",
    "pctBlack": 52.7,
    "LE": 72.3,
    "pctBachPlus": 9.8
  },
  {
    "geoid": "22051027804",
    "pctBlack": 42.6,
    "LE": 77.7,
    "pctBachPlus": 37.9
  },
  {
    "geoid": "22051027805",
    "pctBlack": 52.5,
    "LE": 78.2,
    "pctBachPlus": 22.2
  },
  {
    "geoid": "22051027806",
    "pctBlack": 12.4,
    "LE": 78.5,
    "pctBachPlus": 13.4
  },
  {
    "geoid": "22051027807",
    "pctBlack": 22.7,
    "LE": 79.3,
    "pctBachPlus": 24.8
  },
  {
    "geoid": "22051027809",
    "pctBlack": 28,
    "LE": 76.9,
    "pctBachPlus": 12.1
  },
  {
    "geoid": "22051027811",
    "pctBlack": 81.5,
    "LE": 75.5,
    "pctBachPlus": 15.6
  },
  {
    "geoid": "22051027812",
    "pctBlack": 86.7,
    "LE": 70.8,
    "pctBachPlus": 10.1
  },
  {
    "geoid": "22051027901",
    "pctBlack": 0.7,
    "LE": 75.3,
    "pctBachPlus": 5.3
  },
  {
    "geoid": "22051027902",
    "pctBlack": 0.1,
    "LE": 73.8,
    "pctBachPlus": 7.9
  },
  {
    "geoid": "22051028000",
    "pctBlack": 19.8,
    "LE": 76,
    "pctBachPlus": 13.2
  },
  {
    "geoid": "22051028100",
    "pctBlack": 86.3,
    "LE": 71.8,
    "pctBachPlus": 10.4
  },
  {
    "geoid": "22051028200",
    "pctBlack": 39,
    "LE": 72.2,
    "pctBachPlus": 7.9
  },
  {
    "geoid": "22071000100",
    "pctBlack": 14.7,
    "LE": 78.4,
    "pctBachPlus": 45.6
  },
  {
    "geoid": "22071000200",
    "pctBlack": 83.8,
    "LE": 73.5,
    "pctBachPlus": 16.1
  },
  {
    "geoid": "22071000300",
    "pctBlack": 88.7,
    "LE": 71.3,
    "pctBachPlus": 13.8
  },
  {
    "geoid": "22071000400",
    "pctBlack": 83.1,
    "LE": 75.6,
    "pctBachPlus": 10.9
  },
  {
    "geoid": "22071000601",
    "pctBlack": 99.1,
    "LE": 71.3,
    "pctBachPlus": 4.9
  },
  {
    "geoid": "22071000602",
    "pctBlack": 87,
    "LE": 77.5,
    "pctBachPlus": 13.3
  },
  {
    "geoid": "22071000603",
    "pctBlack": 87.2,
    "LE": 72.9,
    "pctBachPlus": 7.1
  },
  {
    "geoid": "22071000604",
    "pctBlack": 80.4,
    "LE": 73.2,
    "pctBachPlus": 13
  },
  {
    "geoid": "22071000605",
    "pctBlack": 67.5,
    "LE": 70.3,
    "pctBachPlus": 17.9
  },
  {
    "geoid": "22071000606",
    "pctBlack": 54,
    "LE": 75.8,
    "pctBachPlus": 28.5
  },
  {
    "geoid": "22071000607",
    "pctBlack": 52,
    "LE": 80.8,
    "pctBachPlus": 40.4
  },
  {
    "geoid": "22071000611",
    "pctBlack": 81.8,
    "LE": 74.7,
    "pctBachPlus": 8.7
  },
  {
    "geoid": "22071000612",
    "pctBlack": 33.3,
    "LE": 80.8,
    "pctBachPlus": 59.5
  },
  {
    "geoid": "22071000613",
    "pctBlack": 87.8,
    "LE": 72.9,
    "pctBachPlus": 14.5
  },
  {
    "geoid": "22071000615",
    "pctBlack": 67.7,
    "LE": 79.3,
    "pctBachPlus": 21.7
  },
  {
    "geoid": "22071000616",
    "pctBlack": 54.7,
    "LE": 75.3,
    "pctBachPlus": 39.2
  },
  {
    "geoid": "22071000617",
    "pctBlack": 83.3,
    "LE": 73.7,
    "pctBachPlus": 33.9
  },
  {
    "geoid": "22071000618",
    "pctBlack": 55.8,
    "LE": 82.2,
    "pctBachPlus": 47.9
  },
  {
    "geoid": "22071000702",
    "pctBlack": 81.5,
    "LE": 73.1,
    "pctBachPlus": 15.8
  },
  {
    "geoid": "22071000800",
    "pctBlack": 86.3,
    "LE": 71.7,
    "pctBachPlus": 9.8
  },
  {
    "geoid": "22071000904",
    "pctBlack": 91.5,
    "LE": 66.6,
    "pctBachPlus": 7.4
  },
  {
    "geoid": "22071001100",
    "pctBlack": 42.8,
    "LE": 72.1,
    "pctBachPlus": 35.5
  },
  {
    "geoid": "22071001200",
    "pctBlack": 13.8,
    "LE": 71.4,
    "pctBachPlus": 59.2
  },
  {
    "geoid": "22071001301",
    "pctBlack": 74.7,
    "LE": 68.1,
    "pctBachPlus": 23.6
  },
  {
    "geoid": "22071001302",
    "pctBlack": 90.6,
    "LE": 62.6,
    "pctBachPlus": 7
  },
  {
    "geoid": "22071001401",
    "pctBlack": 93.6,
    "LE": 71.3,
    "pctBachPlus": 12
  },
  {
    "geoid": "22071001402",
    "pctBlack": 87.6,
    "LE": 68.7,
    "pctBachPlus": 13.4
  },
  {
    "geoid": "22071001500",
    "pctBlack": 80.5,
    "LE": 72.5,
    "pctBachPlus": 9
  },
  {
    "geoid": "22071001701",
    "pctBlack": 93.7,
    "LE": 78.4,
    "pctBachPlus": 24.6
  },
  {
    "geoid": "22071001702",
    "pctBlack": 75.9,
    "LE": 75.5,
    "pctBachPlus": 30
  },
  {
    "geoid": "22071001720",
    "pctBlack": 91.7,
    "LE": 71.4,
    "pctBachPlus": 8.1
  },
  {
    "geoid": "22071001722",
    "pctBlack": 92.8,
    "LE": 73.4,
    "pctBachPlus": 14.6
  },
  {
    "geoid": "22071001723",
    "pctBlack": 93.8,
    "LE": 78.1,
    "pctBachPlus": 16.4
  },
  {
    "geoid": "22071001724",
    "pctBlack": 91.5,
    "LE": 68.8,
    "pctBachPlus": 21.7
  },
  {
    "geoid": "22071001725",
    "pctBlack": 91.9,
    "LE": 77.2,
    "pctBachPlus": 14.5
  },
  {
    "geoid": "22071001735",
    "pctBlack": 93,
    "LE": 72.7,
    "pctBachPlus": 18.1
  },
  {
    "geoid": "22071001737",
    "pctBlack": 94.4,
    "LE": 75.3,
    "pctBachPlus": 14.1
  },
  {
    "geoid": "22071001739",
    "pctBlack": 98.8,
    "LE": 75.7,
    "pctBachPlus": 28.1
  },
  {
    "geoid": "22071001740",
    "pctBlack": 98.3,
    "LE": 76.6,
    "pctBachPlus": 18.2
  },
  {
    "geoid": "22071001741",
    "pctBlack": 59.7,
    "LE": 72,
    "pctBachPlus": 10.8
  },
  {
    "geoid": "22071001743",
    "pctBlack": 96.3,
    "LE": 72.1,
    "pctBachPlus": 15.3
  },
  {
    "geoid": "22071001744",
    "pctBlack": 97.8,
    "LE": 71.7,
    "pctBachPlus": 16.4
  },
  {
    "geoid": "22071001745",
    "pctBlack": 93.7,
    "LE": 73.8,
    "pctBachPlus": 19.4
  },
  {
    "geoid": "22071001746",
    "pctBlack": 98.1,
    "LE": 69.5,
    "pctBachPlus": 11.9
  },
  {
    "geoid": "22071001747",
    "pctBlack": 74.9,
    "LE": 82.4,
    "pctBachPlus": 45.5
  },
  {
    "geoid": "22071001748",
    "pctBlack": 86.1,
    "LE": 76.8,
    "pctBachPlus": 16.8
  },
  {
    "geoid": "22071001749",
    "pctBlack": 35.9,
    "LE": 78.4,
    "pctBachPlus": 10
  },
  {
    "geoid": "22071001750",
    "pctBlack": 29,
    "LE": 75.9,
    "pctBachPlus": 13.6
  },
  {
    "geoid": "22071001751",
    "pctBlack": 60.6,
    "LE": 74.1,
    "pctBachPlus": 8.2
  },
  {
    "geoid": "22071001900",
    "pctBlack": 63.7,
    "LE": 72.9,
    "pctBachPlus": 13.9
  },
  {
    "geoid": "22071002000",
    "pctBlack": 85.4,
    "LE": 65.3,
    "pctBachPlus": 20.9
  },
  {
    "geoid": "22071002200",
    "pctBlack": 90.8,
    "LE": 71.7,
    "pctBachPlus": 8.6
  },
  {
    "geoid": "22071002300",
    "pctBlack": 94,
    "LE": 70.8,
    "pctBachPlus": 6.2
  },
  {
    "geoid": "22071002401",
    "pctBlack": 81,
    "LE": 78.5,
    "pctBachPlus": 29.4
  },
  {
    "geoid": "22071002402",
    "pctBlack": 89.1,
    "LE": 72.5,
    "pctBachPlus": 18.1
  },
  {
    "geoid": "22071002501",
    "pctBlack": 87,
    "LE": 75.5,
    "pctBachPlus": 24.1
  },
  {
    "geoid": "22071002502",
    "pctBlack": 93.4,
    "LE": 73.1,
    "pctBachPlus": 18
  },
  {
    "geoid": "22071002503",
    "pctBlack": 62.5,
    "LE": 78.1,
    "pctBachPlus": 34.2
  },
  {
    "geoid": "22071002504",
    "pctBlack": 71.2,
    "LE": 76.4,
    "pctBachPlus": 27.8
  },
  {
    "geoid": "22071002600",
    "pctBlack": 7.7,
    "LE": 80.1,
    "pctBachPlus": 47.5
  },
  {
    "geoid": "22071002700",
    "pctBlack": 81.5,
    "LE": 65.6,
    "pctBachPlus": 21
  },
  {
    "geoid": "22071002800",
    "pctBlack": 96.8,
    "LE": 68.3,
    "pctBachPlus": 16
  },
  {
    "geoid": "22071002900",
    "pctBlack": 92.3,
    "LE": 64.8,
    "pctBachPlus": 16.4
  },
  {
    "geoid": "22071003000",
    "pctBlack": 89.8,
    "LE": 68.4,
    "pctBachPlus": 6.7
  },
  {
    "geoid": "22071003100",
    "pctBlack": 88.9,
    "LE": 68.5,
    "pctBachPlus": 5.5
  },
  {
    "geoid": "22071003301",
    "pctBlack": 46.9,
    "LE": 73.6,
    "pctBachPlus": 51.1
  },
  {
    "geoid": "22071003302",
    "pctBlack": 87.2,
    "LE": 79.9,
    "pctBachPlus": 40.1
  },
  {
    "geoid": "22071003303",
    "pctBlack": 66.1,
    "LE": 75.4,
    "pctBachPlus": 26.5
  },
  {
    "geoid": "22071003308",
    "pctBlack": 90.1,
    "LE": 73.5,
    "pctBachPlus": 23.6
  },
  {
    "geoid": "22071003400",
    "pctBlack": 68.5,
    "LE": 73.5,
    "pctBachPlus": 28.1
  },
  {
    "geoid": "22071003500",
    "pctBlack": 84.9,
    "LE": 68.9,
    "pctBachPlus": 20.5
  },
  {
    "geoid": "22071003600",
    "pctBlack": 81.7,
    "LE": 70.9,
    "pctBachPlus": 16.5
  },
  {
    "geoid": "22071003702",
    "pctBlack": 65.1,
    "LE": 81.9,
    "pctBachPlus": 32.4
  },
  {
    "geoid": "22071003800",
    "pctBlack": 1.9,
    "LE": 78.5,
    "pctBachPlus": 57
  },
  {
    "geoid": "22071003900",
    "pctBlack": 50.2,
    "LE": 74.5,
    "pctBachPlus": 40.5
  },
  {
    "geoid": "22071004000",
    "pctBlack": 66.7,
    "LE": 77,
    "pctBachPlus": 26.6
  },
  {
    "geoid": "22071004100",
    "pctBlack": 12.9,
    "LE": 80.1,
    "pctBachPlus": 58.9
  },
  {
    "geoid": "22071004401",
    "pctBlack": 81.5,
    "LE": 66.4,
    "pctBachPlus": 15.4
  },
  {
    "geoid": "22071004500",
    "pctBlack": 60.6,
    "LE": 72.9,
    "pctBachPlus": 37.7
  },
  {
    "geoid": "22071004600",
    "pctBlack": 6.1,
    "LE": 79.9,
    "pctBachPlus": 67.1
  },
  {
    "geoid": "22071004900",
    "pctBlack": 63.6,
    "LE": 71.8,
    "pctBachPlus": 12.5
  },
  {
    "geoid": "22071005400",
    "pctBlack": 17.6,
    "LE": 78.8,
    "pctBachPlus": 58.7
  },
  {
    "geoid": "22071005500",
    "pctBlack": 5.4,
    "LE": 84.2,
    "pctBachPlus": 48
  },
  {
    "geoid": "22071005601",
    "pctBlack": 2.7,
    "LE": 83.2,
    "pctBachPlus": 65.1
  },
  {
    "geoid": "22071005602",
    "pctBlack": 3.9,
    "LE": 88.1,
    "pctBachPlus": 59.6
  },
  {
    "geoid": "22071005603",
    "pctBlack": 2.7,
    "LE": 79.2,
    "pctBachPlus": 64.7
  },
  {
    "geoid": "22071005604",
    "pctBlack": 3.2,
    "LE": 80.9,
    "pctBachPlus": 73.6
  },
  {
    "geoid": "22071006300",
    "pctBlack": 50.9,
    "LE": 75.9,
    "pctBachPlus": 21.9
  },
  {
    "geoid": "22071006400",
    "pctBlack": 44,
    "LE": 77,
    "pctBachPlus": 36.1
  },
  {
    "geoid": "22071006500",
    "pctBlack": 27.3,
    "LE": 77.6,
    "pctBachPlus": 45.9
  },
  {
    "geoid": "22071006900",
    "pctBlack": 98.3,
    "LE": 67.5,
    "pctBachPlus": 3.5
  },
  {
    "geoid": "22071007101",
    "pctBlack": 71.2,
    "LE": 74.2,
    "pctBachPlus": 16.6
  },
  {
    "geoid": "22071007200",
    "pctBlack": 82.2,
    "LE": 71.7,
    "pctBachPlus": 7.2
  },
  {
    "geoid": "22071007501",
    "pctBlack": 91,
    "LE": 72.8,
    "pctBachPlus": 14.2
  },
  {
    "geoid": "22071007502",
    "pctBlack": 86.4,
    "LE": 72.1,
    "pctBachPlus": 11.4
  },
  {
    "geoid": "22071007604",
    "pctBlack": 3.2,
    "LE": 80.4,
    "pctBachPlus": 74.7
  },
  {
    "geoid": "22071007605",
    "pctBlack": 83.3,
    "LE": 77.8,
    "pctBachPlus": 11.2
  },
  {
    "geoid": "22071007606",
    "pctBlack": 11.4,
    "LE": 82.7,
    "pctBachPlus": 58.9
  },
  {
    "geoid": "22071007700",
    "pctBlack": 11.1,
    "LE": 80.3,
    "pctBachPlus": 72.1
  },
  {
    "geoid": "22071008200",
    "pctBlack": 13.8,
    "LE": 75.5,
    "pctBachPlus": 54.2
  },
  {
    "geoid": "22071008300",
    "pctBlack": 13.8,
    "LE": 79,
    "pctBachPlus": 62.4
  },
  {
    "geoid": "22071008400",
    "pctBlack": 47.1,
    "LE": 78,
    "pctBachPlus": 49.6
  },
  {
    "geoid": "22071008600",
    "pctBlack": 81.4,
    "LE": 72.9,
    "pctBachPlus": 10.9
  },
  {
    "geoid": "22071008800",
    "pctBlack": 21.5,
    "LE": 75.5,
    "pctBachPlus": 57.7
  },
  {
    "geoid": "22071009000",
    "pctBlack": 1.8,
    "LE": 80.7,
    "pctBachPlus": 83.2
  },
  {
    "geoid": "22071009100",
    "pctBlack": 41,
    "LE": 73.8,
    "pctBachPlus": 43.8
  },
  {
    "geoid": "22071009200",
    "pctBlack": 95.3,
    "LE": 72.1,
    "pctBachPlus": 7.3
  },
  {
    "geoid": "22071009400",
    "pctBlack": 86,
    "LE": 62.3,
    "pctBachPlus": 8.5
  },
  {
    "geoid": "22071009600",
    "pctBlack": 29.7,
    "LE": 74.4,
    "pctBachPlus": 51.9
  },
  {
    "geoid": "22071009700",
    "pctBlack": 42.2,
    "LE": 76.1,
    "pctBachPlus": 45.7
  },
  {
    "geoid": "22071009900",
    "pctBlack": 14,
    "LE": 75.7,
    "pctBachPlus": 63.1
  },
  {
    "geoid": "22071010000",
    "pctBlack": 73.4,
    "LE": 74.3,
    "pctBachPlus": 34.8
  },
  {
    "geoid": "22071010200",
    "pctBlack": 77.5,
    "LE": 71.7,
    "pctBachPlus": 31.6
  },
  {
    "geoid": "22071010300",
    "pctBlack": 82.5,
    "LE": 75.7,
    "pctBachPlus": 24.5
  },
  {
    "geoid": "22071010600",
    "pctBlack": 29.8,
    "LE": 75.3,
    "pctBachPlus": 57.3
  },
  {
    "geoid": "22071010700",
    "pctBlack": 10,
    "LE": 82.1,
    "pctBachPlus": 71.6
  },
  {
    "geoid": "22071010800",
    "pctBlack": 5.8,
    "LE": 81.3,
    "pctBachPlus": 83.6
  },
  {
    "geoid": "22071010900",
    "pctBlack": 40.6,
    "LE": 83.7,
    "pctBachPlus": 51.6
  },
  {
    "geoid": "22071011100",
    "pctBlack": 60.5,
    "LE": 75.4,
    "pctBachPlus": 33.8
  },
  {
    "geoid": "22071011200",
    "pctBlack": 28.3,
    "LE": 79.5,
    "pctBachPlus": 59.7
  },
  {
    "geoid": "22071011400",
    "pctBlack": 1.9,
    "LE": 81,
    "pctBachPlus": 77.6
  },
  {
    "geoid": "22071011500",
    "pctBlack": 6.5,
    "LE": 81.4,
    "pctBachPlus": 74.2
  },
  {
    "geoid": "22071011600",
    "pctBlack": 3.5,
    "LE": 78.7,
    "pctBachPlus": 85.1
  },
  {
    "geoid": "22071011700",
    "pctBlack": 0.4,
    "LE": 80.7,
    "pctBachPlus": 85.8
  },
  {
    "geoid": "22071012000",
    "pctBlack": 4.4,
    "LE": 86.8,
    "pctBachPlus": 81.6
  },
  {
    "geoid": "22071012101",
    "pctBlack": 5.5,
    "LE": 82.8,
    "pctBachPlus": 70.8
  },
  {
    "geoid": "22071012200",
    "pctBlack": 6.5,
    "LE": 80.5,
    "pctBachPlus": 80.2
  },
  {
    "geoid": "22071012300",
    "pctBlack": 35.3,
    "LE": 74.1,
    "pctBachPlus": 50.2
  },
  {
    "geoid": "22071012400",
    "pctBlack": 27.9,
    "LE": 80.1,
    "pctBachPlus": 62.8
  },
  {
    "geoid": "22071012500",
    "pctBlack": 23.8,
    "LE": 77.3,
    "pctBachPlus": 58.8
  },
  {
    "geoid": "22071012600",
    "pctBlack": 6.4,
    "LE": 79.9,
    "pctBachPlus": 73.7
  },
  {
    "geoid": "22071012700",
    "pctBlack": 23.4,
    "LE": 78.2,
    "pctBachPlus": 60
  },
  {
    "geoid": "22071012800",
    "pctBlack": 18.3,
    "LE": 74.1,
    "pctBachPlus": 71.2
  },
  {
    "geoid": "22071012900",
    "pctBlack": 31.6,
    "LE": 75.4,
    "pctBachPlus": 56.6
  },
  {
    "geoid": "22071013000",
    "pctBlack": 51.5,
    "LE": 77.2,
    "pctBachPlus": 39.3
  },
  {
    "geoid": "22071013100",
    "pctBlack": 70.7,
    "LE": 73.5,
    "pctBachPlus": 16.4
  },
  {
    "geoid": "22071013301",
    "pctBlack": 4.4,
    "LE": 85.1,
    "pctBachPlus": 71.6
  },
  {
    "geoid": "22071013302",
    "pctBlack": 21.5,
    "LE": 80.4,
    "pctBachPlus": 77.9
  },
  {
    "geoid": "22071013400",
    "pctBlack": 23.5,
    "LE": 78.8,
    "pctBachPlus": 62.9
  },
  {
    "geoid": "22071013600",
    "pctBlack": 49.3,
    "LE": 68.5,
    "pctBachPlus": 36.8
  },
  {
    "geoid": "22071013700",
    "pctBlack": 94.8,
    "LE": 66,
    "pctBachPlus": 7.6
  },
  {
    "geoid": "22071013800",
    "pctBlack": 95.9,
    "LE": 69.9,
    "pctBachPlus": 16.7
  },
  {
    "geoid": "22071013900",
    "pctBlack": 42.7,
    "LE": 81.2,
    "pctBachPlus": 51.2
  },
  {
    "geoid": "22071014000",
    "pctBlack": 92.1,
    "LE": 72.1,
    "pctBachPlus": 2.3
  },
  {
    "geoid": "22071014200",
    "pctBlack": 32.8,
    "LE": 76.7,
    "pctBachPlus": 55.4
  },
  {
    "geoid": "22071014300",
    "pctBlack": 87.8,
    "LE": 69.5,
    "pctBachPlus": 8.9
  },
  {
    "geoid": "22071014400",
    "pctBlack": 36.5,
    "LE": 77.1,
    "pctBachPlus": 43.6
  },
  {
    "geoid": "22075050100",
    "pctBlack": 84,
    "LE": 75.5,
    "pctBachPlus": 9.5
  },
  {
    "geoid": "22075050200",
    "pctBlack": 2.8,
    "LE": 78.4,
    "pctBachPlus": 15.3
  },
  {
    "geoid": "22075050300",
    "pctBlack": 11.1,
    "LE": 77.2,
    "pctBachPlus": 22.4
  },
  {
    "geoid": "22075050500",
    "pctBlack": 56.4,
    "LE": 71.5,
    "pctBachPlus": 4.2
  },
  {
    "geoid": "22075050600",
    "pctBlack": 28.1,
    "LE": 71.1,
    "pctBachPlus": 5
  },
  {
    "geoid": "22075050800",
    "pctBlack": 20.7,
    "LE": 72.2,
    "pctBachPlus": 6.4
  },
  {
    "geoid": "22087030103",
    "pctBlack": 21.6,
    "LE": 72.6,
    "pctBachPlus": 5.1
  },
  {
    "geoid": "22087030104",
    "pctBlack": 1.6,
    "LE": 73,
    "pctBachPlus": 9.8
  },
  {
    "geoid": "22087030203",
    "pctBlack": 6.9,
    "LE": 73.5,
    "pctBachPlus": 14
  },
  {
    "geoid": "22087030204",
    "pctBlack": 69.5,
    "LE": 71.9,
    "pctBachPlus": 7.3
  },
  {
    "geoid": "22087030206",
    "pctBlack": 9.4,
    "LE": 73,
    "pctBachPlus": 22.5
  },
  {
    "geoid": "22087030207",
    "pctBlack": 10.2,
    "LE": 78.1,
    "pctBachPlus": 21.1
  },
  {
    "geoid": "22087030208",
    "pctBlack": 11.6,
    "LE": 77,
    "pctBachPlus": 14.6
  },
  {
    "geoid": "22087030209",
    "pctBlack": 17.6,
    "LE": 76.9,
    "pctBachPlus": 11.4
  },
  {
    "geoid": "22087030300",
    "pctBlack": 13.2,
    "LE": 76.9,
    "pctBachPlus": 22.8
  },
  {
    "geoid": "22087030400",
    "pctBlack": 12.3,
    "LE": 74.4,
    "pctBachPlus": 6.6
  },
  {
    "geoid": "22087030500",
    "pctBlack": 16.4,
    "LE": 74.9,
    "pctBachPlus": 14.5
  },
  {
    "geoid": "22087030602",
    "pctBlack": 16.1,
    "LE": 74.2,
    "pctBachPlus": 11.5
  },
  {
    "geoid": "22087030700",
    "pctBlack": 15,
    "LE": 75.5,
    "pctBachPlus": 12.4
  },
  {
    "geoid": "22087030800",
    "pctBlack": 18.8,
    "LE": 72.4,
    "pctBachPlus": 13.4
  },
  {
    "geoid": "22089060100",
    "pctBlack": 20.3,
    "LE": 78.1,
    "pctBachPlus": 25
  },
  {
    "geoid": "22089062100",
    "pctBlack": 32.3,
    "LE": 79.5,
    "pctBachPlus": 13.2
  },
  {
    "geoid": "22089062301",
    "pctBlack": 24.1,
    "LE": 77.9,
    "pctBachPlus": 41.5
  },
  {
    "geoid": "22089062302",
    "pctBlack": 21.3,
    "LE": 80.6,
    "pctBachPlus": 24.3
  },
  {
    "geoid": "22089062400",
    "pctBlack": 39.3,
    "LE": 72.2,
    "pctBachPlus": 6
  },
  {
    "geoid": "22089062500",
    "pctBlack": 6.2,
    "LE": 76.1,
    "pctBachPlus": 7.8
  },
  {
    "geoid": "22089062700",
    "pctBlack": 51.5,
    "LE": 75.3,
    "pctBachPlus": 13.4
  },
  {
    "geoid": "22089062800",
    "pctBlack": 51.2,
    "LE": 72.7,
    "pctBachPlus": 17.5
  },
  {
    "geoid": "22089062900",
    "pctBlack": 10,
    "LE": 76.5,
    "pctBachPlus": 21.2
  },
  {
    "geoid": "22089063000",
    "pctBlack": 42.9,
    "LE": 77.8,
    "pctBachPlus": 18.7
  },
  {
    "geoid": "22089063100",
    "pctBlack": 3.1,
    "LE": 79.8,
    "pctBachPlus": 27.4
  },
  {
    "geoid": "22089063200",
    "pctBlack": 2.2,
    "LE": 75.8,
    "pctBachPlus": 13.1
  },
  {
    "geoid": "22093040100",
    "pctBlack": 39.5,
    "LE": 75,
    "pctBachPlus": 13.6
  },
  {
    "geoid": "22093040200",
    "pctBlack": 40.3,
    "LE": 75.1,
    "pctBachPlus": 15
  },
  {
    "geoid": "22093040300",
    "pctBlack": 18,
    "LE": 80.4,
    "pctBachPlus": 14
  },
  {
    "geoid": "22093040400",
    "pctBlack": 68.8,
    "LE": 74,
    "pctBachPlus": 10.1
  },
  {
    "geoid": "22093040500",
    "pctBlack": 93.9,
    "LE": 75.1,
    "pctBachPlus": 9.9
  },
  {
    "geoid": "22093040600",
    "pctBlack": 75.7,
    "LE": 77,
    "pctBachPlus": 18.4
  },
  {
    "geoid": "22093040700",
    "pctBlack": 35.2,
    "LE": 79,
    "pctBachPlus": 15.8
  },
  {
    "geoid": "22095070100",
    "pctBlack": 19.6,
    "LE": 81,
    "pctBachPlus": 27.4
  },
  {
    "geoid": "22095070200",
    "pctBlack": 77.4,
    "LE": 73.9,
    "pctBachPlus": 21.4
  },
  {
    "geoid": "22095070300",
    "pctBlack": 32.3,
    "LE": 76.8,
    "pctBachPlus": 21.2
  },
  {
    "geoid": "22095070400",
    "pctBlack": 34,
    "LE": 78.2,
    "pctBachPlus": 25.4
  },
  {
    "geoid": "22095070500",
    "pctBlack": 66.5,
    "LE": 72.1,
    "pctBachPlus": 8.9
  },
  {
    "geoid": "22095070600",
    "pctBlack": 59.3,
    "LE": 75.6,
    "pctBachPlus": 10.2
  },
  {
    "geoid": "22095070700",
    "pctBlack": 31.9,
    "LE": 75.6,
    "pctBachPlus": 9.9
  },
  {
    "geoid": "22095070800",
    "pctBlack": 90.8,
    "LE": 70.7,
    "pctBachPlus": 14.5
  },
  {
    "geoid": "22095070900",
    "pctBlack": 54.8,
    "LE": 73,
    "pctBachPlus": 12.3
  },
  {
    "geoid": "22095071000",
    "pctBlack": 36.1,
    "LE": 72.7,
    "pctBachPlus": 10.7
  },
  {
    "geoid": "22095071100",
    "pctBlack": 87,
    "LE": 75.3,
    "pctBachPlus": 15.4
  },
  {
    "geoid": "22103040102",
    "pctBlack": 3.1,
    "LE": 75.8,
    "pctBachPlus": 19.9
  },
  {
    "geoid": "22103040103",
    "pctBlack": 0,
    "LE": 76.4,
    "pctBachPlus": 20.2
  },
  {
    "geoid": "22103040104",
    "pctBlack": 1.1,
    "LE": 77.6,
    "pctBachPlus": 23
  },
  {
    "geoid": "22103040201",
    "pctBlack": 6.1,
    "LE": 78.4,
    "pctBachPlus": 21.5
  },
  {
    "geoid": "22103040202",
    "pctBlack": 1.3,
    "LE": 78.5,
    "pctBachPlus": 27.8
  },
  {
    "geoid": "22103040303",
    "pctBlack": 3.6,
    "LE": 79.3,
    "pctBachPlus": 45.4
  },
  {
    "geoid": "22103040304",
    "pctBlack": 0,
    "LE": 83.6,
    "pctBachPlus": 62.3
  },
  {
    "geoid": "22103040305",
    "pctBlack": 6.1,
    "LE": 80.5,
    "pctBachPlus": 41.6
  },
  {
    "geoid": "22103040400",
    "pctBlack": 2.3,
    "LE": 81.4,
    "pctBachPlus": 44.3
  },
  {
    "geoid": "22103040501",
    "pctBlack": 45.4,
    "LE": 74.1,
    "pctBachPlus": 17.7
  },
  {
    "geoid": "22103040502",
    "pctBlack": 25.2,
    "LE": 77.6,
    "pctBachPlus": 30.4
  },
  {
    "geoid": "22103040601",
    "pctBlack": 0,
    "LE": 78.1,
    "pctBachPlus": 55.5
  },
  {
    "geoid": "22103040602",
    "pctBlack": 0,
    "LE": 78.5,
    "pctBachPlus": 49.6
  },
  {
    "geoid": "22103040604",
    "pctBlack": 4.9,
    "LE": 81.4,
    "pctBachPlus": 23.7
  },
  {
    "geoid": "22103040605",
    "pctBlack": 6.9,
    "LE": 79.2,
    "pctBachPlus": 33.4
  },
  {
    "geoid": "22103040701",
    "pctBlack": 23.9,
    "LE": 78.4,
    "pctBachPlus": 21.4
  },
  {
    "geoid": "22103040705",
    "pctBlack": 15.3,
    "LE": 75.4,
    "pctBachPlus": 22
  },
  {
    "geoid": "22103040706",
    "pctBlack": 2.9,
    "LE": 75.7,
    "pctBachPlus": 17.1
  },
  {
    "geoid": "22103040709",
    "pctBlack": 9.6,
    "LE": 76.6,
    "pctBachPlus": 25.6
  },
  {
    "geoid": "22103040710",
    "pctBlack": 11.9,
    "LE": 79.4,
    "pctBachPlus": 25.9
  },
  {
    "geoid": "22103040801",
    "pctBlack": 17.8,
    "LE": 76.7,
    "pctBachPlus": 23.2
  },
  {
    "geoid": "22103040803",
    "pctBlack": 49,
    "LE": 75,
    "pctBachPlus": 18.1
  },
  {
    "geoid": "22103040900",
    "pctBlack": 58.6,
    "LE": 69.5,
    "pctBachPlus": 10.1
  },
  {
    "geoid": "22103041002",
    "pctBlack": 4.4,
    "LE": 77.6,
    "pctBachPlus": 24.3
  },
  {
    "geoid": "22103041003",
    "pctBlack": 12.2,
    "LE": 78.6,
    "pctBachPlus": 24.6
  },
  {
    "geoid": "22103041004",
    "pctBlack": 3.6,
    "LE": 76.7,
    "pctBachPlus": 26.5
  },
  {
    "geoid": "22103041101",
    "pctBlack": 20.3,
    "LE": 75.4,
    "pctBachPlus": 12
  },
  {
    "geoid": "22103041102",
    "pctBlack": 26.7,
    "LE": 75.7,
    "pctBachPlus": 21.3
  },
  {
    "geoid": "22103041103",
    "pctBlack": 31.1,
    "LE": 69.8,
    "pctBachPlus": 10.9
  },
  {
    "geoid": "22103041104",
    "pctBlack": 16.3,
    "LE": 75.9,
    "pctBachPlus": 27.3
  },
  {
    "geoid": "22103041202",
    "pctBlack": 24.2,
    "LE": 76.6,
    "pctBachPlus": 13.6
  },
  {
    "geoid": "22103041204",
    "pctBlack": 21.7,
    "LE": 75.8,
    "pctBachPlus": 18.1
  },
  {
    "geoid": "22103041207",
    "pctBlack": 2.8,
    "LE": 78.8,
    "pctBachPlus": 37.6
  },
  {
    "geoid": "22103041208",
    "pctBlack": 0.5,
    "LE": 83,
    "pctBachPlus": 69.5
  },
  {
    "geoid": "22103041209",
    "pctBlack": 2.7,
    "LE": 80.3,
    "pctBachPlus": 57
  },
  {
    "geoid": "22103041210",
    "pctBlack": 0.9,
    "LE": 76.9,
    "pctBachPlus": 25.8
  },
  {
    "geoid": "22103041211",
    "pctBlack": 0.2,
    "LE": 78.8,
    "pctBachPlus": 47.7
  },
  {
    "geoid": "22103041300",
    "pctBlack": 7.6,
    "LE": 81.5,
    "pctBachPlus": 44.1
  }
]
